import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

const TAX_BAR_HEIGHT = 44;

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    card: {
      backgroundColor: theme.goal.sidecar.card.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    cardHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      gap: spacing.s,
    },
    cardLabel: {
      fontSize: 14,
      fontWeight: 600,
      margin: 0,
    },
    badge: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.xxs,
      padding: `${spacing.xxs}px ${spacing.s}px`,
      borderRadius: constants.radius.button,
      backgroundColor: theme.background,
      flexShrink: 0,
    },
    badgeText: {
      fontSize: 11,
      fontWeight: 600,
      margin: 0,
      whiteSpace: "nowrap",
    },
    amountRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.s,
      marginTop: spacing.s,
    },
    taxBar: {
      height: TAX_BAR_HEIGHT,
      borderRadius: constants.radius.view,
      backgroundColor: theme.goal.sidecar.negative,
      flexShrink: 0,
    },
    positiveBar: {
      width: 6,
      height: TAX_BAR_HEIGHT,
      borderRadius: constants.radius.view,
      backgroundColor: theme.goal.sidecar.positive,
      flexShrink: 0,
    },
    negativeAmount: {
      fontSize: 32,
      fontWeight: 700,
      margin: 0,
      color: theme.goal.sidecar.negative,
      whiteSpace: "nowrap",
    },
    positiveAmount: {
      fontSize: 32,
      fontWeight: 700,
      margin: 0,
      color: theme.goal.sidecar.positive,
      whiteSpace: "nowrap",
    },
    caption: {
      fontSize: 10,
      fontWeight: 500,
      margin: 0,
      marginTop: spacing.xs,
      color: theme.text.tertiary,
    },
    inputRow: {
      display: "flex",
      flexDirection: "row",
      gap: spacing.s,
    },
    inputCard: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: spacing.xxs,
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      cursor: "pointer",
      userSelect: "none",
    },
    inputLabelRow: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      gap: spacing.xxs,
    },
    inputLabel: {
      fontSize: 11,
      fontWeight: 500,
      margin: 0,
      color: theme.text.secondary,
    },
    inputValue: {
      fontSize: 14,
      fontWeight: 600,
      margin: 0,
    },
  };

  return styles;
};
